module.exports = __webpack_public_path__ + "img/new-food-thai.b1cd2aa0.png";